
import { Component, Mixins } from 'vue-property-decorator';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';
import ResolveChildDialog from '@/components/ResolveChildDialog.vue';

@Component({
  components: {
    ResolveChildDialog,
  },
})
export default class OperationChildActions extends Mixins(OperationComponentMixin) {
  resolveChildDialog = false

  get operationAllowedUsers(): number[] {
    return this.operation.allowedUsers.substring(1, this.operation.allowedUsers.length - 1).split(':')
      .map((s: string) => Number(s)) || [];
  }

  get isCurrentUserAllowed(): boolean {
    return this.operationAllowedUsers.includes(this.user.id);
  }

  onResolveChild(projectId: number, childProjectId: number | null = null) {
    console.log(`${this.constructor.name}: onResolveChild() projectId = ${projectId} childProjectId = ${childProjectId}`); // eslint-disable-line no-console
    this.resolveChildDialog = true;
  }
}
